module.exports = __webpack_public_path__ + "img/staff.78c32130.svg";